import { ChevronUp, ChevronDown } from 'lucide-react';

interface SortConfig {
 key: string | null;
 direction: string | null;
}

const SortableHeader =
  ({ label, sortKey, onSort, sortConfig }:
  { label: string; sortKey: string; onSort: (key: string) => void; sortConfig: SortConfig}

  ): React.JSX.Element => {

    return (
      <th
        className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer hover:bg-gray-100 select-none"
        onClick={() => onSort(sortKey)}
      >
        <div className="flex items-center space-x-1">
          <span>{label}</span>
          <div className="flex flex-col">
            <ChevronUp
              size={12}
              className={`${
                sortConfig.key === sortKey && sortConfig.direction === 'asc'
                  ? 'text-blue-600'
                  : 'text-gray-400'
              }`}
            />
            <ChevronDown
              size={12}
              className={`${
                sortConfig.key === sortKey && sortConfig.direction === 'desc'
                  ? 'text-blue-600'
                  : 'text-gray-400'
              } -mt-1`}
            />
          </div>
        </div>
      </th>
    );
  };
export default SortableHeader;
